/**
 * Activity Icon Constants
 *
 * Valid activity icon identifiers for trip activities.
 * These icons must match the symbols available in the ItinerariesSvg component.
 *
 * Icons are used for:
 * - Map marker visualization
 * - Activity type representation in UI
 * - Custom activity appearance
 *
 * NOTE: This must match the backend ACTIVITY_ICONS constant
 */

/**
 * Valid activity icon identifiers
 * Must correspond to available SVG icons in ItinerariesSvg component
 */
export const ACTIVITY_ICONS = [
  'hotel',
  'restaurant',
  'landmark',
  'museum',
  'amusement',
  'nightlife',
  'event',
  'transport',
  'shop',
  'park',
  'other'
] as const;

export type ActivityIcon = (typeof ACTIVITY_ICONS)[number];

export function isValidActivityIcon(icon: string): icon is ActivityIcon {
  return ACTIVITY_ICONS.includes(icon as ActivityIcon);
}
